define(function (require) {
    var avalon = require('avalon'),
        ajax = require('ajax'),
        dialog = require('dialog'),
        tool = require('toolLoaderPC');

    var hiddenValues, rewardConfirmKit;

    var vmodel = avalon.define({
        $id: 'cooperIndexController',
        cooper_amount: '', // 打赏总额
        title: '', // 打赏标题
        finalMoney: '0', // 最终总额
        usable_voucher: '0', // 代金券总额
        usedVoucher: false, // 是否使用代金券
        usedVoucherChange: function () {
            if (vmodel.usedVoucher) {
                var t =
                    tool.toNumber(vmodel.cooper_amount) -
                    tool.toNumber(vmodel.usable_voucher);
                vmodel.finalMoney = t >= 0 ? t : 0;
            } else {
                vmodel.finalMoney = vmodel.cooper_amount;
            }
        },
        pay: function () {
            tool.singleWay('order-confirm-pay', function (key) {
                rewardConfirmKit = this;

                ajax
                    .post('create.html', {
                        cooper_amount: hiddenValues.cooper_amount,
                        use_coupon: vmodel.usedVoucher ? '1' : '0'
                    })
                    .done(function (response) {
                        if (
                            response.type == 'error' ||
                            response.type == 'err'
                        ) {
                            return dialog.confirm(
                                response.msg,
                                function () {
                                    // ajax.pjax('/cart_list.html');
                                },
                                function () {
                                    // ajax.pjax('/cart_list.html');
                                }
                            );
                        }
                        ajax.pjax(response.url);

                        rewardConfirmKit.resolve(key);
                    })
                    .fail(function () {
                        rewardConfirmKit.resolve(key);
                    });
            });
        }
    });

    return {
        init: function () {
            hiddenValues = tool.getHiddenValues('#js-local-hiddens');

            vmodel.cooper_amount = hiddenValues.cooper_amount;
            vmodel.title = hiddenValues.title;

            if (hiddenValues.coupon && tool.toNumber(hiddenValues.coupon) > 0) {
                vmodel.usedVoucher = true;
                vmodel.usable_voucher = hiddenValues.coupon;

                var cooper_amount = tool.toNumber(hiddenValues.cooper_amount);
                var coupon = tool.toNumber(hiddenValues.coupon);
                if (cooper_amount - coupon >= 0) {
                    vmodel.finalMoney = cooper_amount - coupon;
                } else {
                    vmodel.finalMoney = coupon - cooper_amount;
                }
            }

            console.log(hiddenValues);
        },
        clear: function () {}
    };
});



// WEBPACK FOOTER //
// ./src/js_modules/cooperIndexController.js